import { useState, useRef, MouseEvent, useEffect } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import useResponsive from '../../hooks/useResponsive';

const ImageWithZoomAndScroll = ({ imageUrl }: { imageUrl: string | null }) => {
    const [scale, setScale] = useState(1);
    const { windowHeight } = useWindowDimensions()
    const { isDesktop } = useResponsive()
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });

    // const imageUrls = `${imageUrl}?timestamp=${new Date().getTime()}`;
    const imageUrls = imageUrl ?? ""


    // Zoom In Handler
    const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3)); // Max zoom: 3

    // Zoom Out Handler
    const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 1)); // Min zoom: 1

    // Start Dragging
    const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
        setIsDragging(true);
        setStartPosition({
            x: e.clientX + (containerRef.current?.scrollLeft || 0),
            y: e.clientY + (containerRef.current?.scrollTop || 0),
        });
    };

    // Dragging to Simulate Scrolling
    const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
        if (!isDragging || !containerRef.current) return;

        const dx = startPosition.x - e.clientX;
        const dy = startPosition.y - e.clientY;

        containerRef.current.scrollLeft = dx;
        containerRef.current.scrollTop = dy;
    };

    // Stop Dragging
    const handleMouseUp = () => setIsDragging(false);



    return (
        <Box
            sx={{
                display: "flex",
                width: isDesktop ? '100%' : "90%",
                // height: '100%',
                position: 'relative',
                overflow: 'hidden',
                // backgroundColor: '#f0f0f0',
                border: 1,
                borderColor: '#f2f0ef',
                borderRadius: 2
            }}
        >
            {/* Scrollable Image Container */}
            <Box
                ref={containerRef}
                sx={{
                    width: "100%",
                    // height: "600px",
                    // minHeight: "500px",
                    // maxHeight: "600px",
                    overflow: 'auto',
                    cursor: isDragging ? 'grabbing' : 'grab',
                }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
            >
                {imageUrl ? (
                    <img
                        src={imageUrls}
                        alt="Zoomable content"
                        style={{
                            width: `${100 * scale}%`,
                            height: `${100 * scale}%`,
                            objectFit: 'contain',
                            display: 'block',
                            transition: 'transform 0.3s ease-out',
                            // WebkitMaskImage: `url(${imgSrc})`
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: '100%',
                            height: windowHeight - 190,
                            minHeight: "500px",
                            maxHeight: "600px",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: '#888',
                            fontSize: '18px',
                        }}
                    >
                        Geen afbeelding beschikbaar
                    </Box>
                )}
            </Box>

            {/* Zoom Controls */}
            {
                imageUrl &&
                <Box
                    sx={{
                        position: 'absolute',
                        top: 10,
                        left: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        zIndex: 1,
                    }}
                >
                    <Box
                        sx={{
                            width: 35,
                            height: 35,
                            backgroundColor: 'white',
                            borderRadius: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <IconButton onClick={zoomIn} color="primary" size="large">
                            <AddIcon />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            width: 35,
                            height: 35,
                            backgroundColor: 'white',
                            borderRadius: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <IconButton onClick={zoomOut} color="primary" size="large">
                            <RemoveIcon />
                        </IconButton>
                    </Box>
                </Box>
            }
        </Box>
    );
};

export default ImageWithZoomAndScroll;